export default (currentLocation, cartItem) => {
    
    let itemPrice = 0.00;

    // get the max toppings section that we're in
    if (currentLocation.customPizzas) {
        currentLocation.customPizzas.forEach((theCustomPizza) => {
            if (theCustomPizza.max_toppings == cartItem.max_toppings) {   
                
                // get the price from the selected size
                theCustomPizza.prices.forEach((thePrice) => {
                    if (thePrice.size_id == cartItem.price_id) {
                        itemPrice += parseFloat(thePrice.price);
                    }
                });
            }
        });

        // get the price for the crust
        currentLocation.customCrusts.forEach((theCrust) => {
            if (theCrust.id == cartItem.crust_id) {
                theCrust.prices.forEach((thePrice) => {
                    if (thePrice.size_id == cartItem.price_id) {
                        itemPrice += parseFloat(thePrice.price);
                    }
                });
            }
        });

        // get the price for the sauce
        currentLocation.customSauces.forEach((theSauce) => {
            if (theSauce.id == cartItem.sauce_id) {
                theSauce.prices.forEach((thePrice) => {
                    if (thePrice.size_id == cartItem.price_id) {
                        itemPrice += parseFloat(thePrice.price);
                    }
                });
            }
        });
    }

    itemPrice *= cartItem.quantity;
    
    return itemPrice;
}